import { ExploreTabType, SearchType } from '../../types'
import { NewsSearchType } from '../libraries/mfc/MfcJsTypes'
import { AppRouter, HISTORY } from '../state/state.router'
import { getSlugAndId, idToSlug } from '../state/state.users'
import { routerPush } from '../utilities/router'
import { TransitionTypes } from '../utilities/transitions'
import { safelyOpenwindow } from '../utilities/window'

export const goToHome = () => {
    routerPush('/')
}

export const goToMessage = (
    slug: string,
    transitionSource = TransitionTypes.NONE,
) => {
    if (!slug) return
    return routerPush(`/message/${slug}`, {
        transitionSource,
    })
}

export const goBackToPreviousRoute = (fallback = '/', useReferrer = false) => {
    if (useReferrer) return routerPush(HISTORY.referrer ?? fallback)
    const PREVIOUS_ROUTE = HISTORY.lastRoute[HISTORY.lastRoute.length - 2]
    if (PREVIOUS_ROUTE)
        return routerPush(PREVIOUS_ROUTE.visibleRoute, {
            baseRoute: PREVIOUS_ROUTE.baseRoute,
        })
    return routerPush(fallback)
}

export const goToMessages = () => {
    routerPush('/messages')
}

export const goToNewsFromModel = (slug: string) => {
    routerPush(`/news?query=${slug}&type=username`)
}

export const goToNews = (query: string, type: NewsSearchType) => {
    routerPush(`/news?query=${query ?? ''}&type=${type ?? ''}`)
}

export const openProfile = (slugOrId: string | number) => {
    const [slug] = getSlugAndId(slugOrId)
    return routerPush(`/${slug}`)
}

export const goToMFCProfile = (slug: string) => {
    safelyOpenwindow('https://profiles.myfreecams.com/' + slug)
}

export const goToRoom = (slug: string, loungeSurrogateID?: number) => {
    if (!slug) {
        return goToRooms()
    }
    // const restorePath = buildRestorePath()
    if (loungeSurrogateID) {
        const surrogateSlug = idToSlug[loungeSurrogateID]
        routerPush(`/room/${slug}/${surrogateSlug}`)
        return
    }

    routerPush(`/room/${slug}`)
}

export const goToRooms = () => {
    routerPush('/rooms')
}

export const goToNotes = (name) => {
    routerPush(`/notes?username=${name}`)
}

export const setLoungeSurrogateURL = (
    loungeID: number,
    loungeSurrogateID?: number,
) => {
    const surrogateID = AppRouter.route.surrogateID
    if (surrogateID === loungeSurrogateID) {
        return
    }

    goToRoom(idToSlug[loungeID], loungeSurrogateID)
}

const goToExploreView =
    (view = '' as ExploreTabType) =>
    () => {
        routerPush('/search' + (view ? `?view=${view}` : ''))
    }

export const goToExploreGroupShowView = goToExploreView('group-shows')
export const goToExploreTrendingView = goToExploreView('trending')
export const goToExplorePopularView = goToExploreView('popular')
export const goToExploreMissMFCView = goToExploreView('missmfc')
export const goToExploreNewView = goToExploreView('new')
export const goToExploreDefaultView = goToExploreView()

export const goToModelsYouMayLike = (usernameOrSlug: string) => {
    routerPush(`/recommendations/${usernameOrSlug.toLocaleLowerCase()}`)
}

export const goToSearchPage = ({ query, type }: SearchProps) => {
    const queryParam = query ? `?query=${query}` : ''
    const typeParam = query && type ? `&type=${type}` : ''

    const path = queryParam ? `/search${queryParam}${typeParam}` : `/search`

    routerPush(path)
}

export type SearchProps = {
    type?: SearchType
    referrer?: string
    query?: string
}
